import { customerApi } from "../../utils/apiConfig";

// Backend: /api/v1/kurumsal-hafiza/admin/konteyner-plan (routes/planlama/konteynerPlan.js)
const BASE = "/konteyner-plan";

const authConfig = (params) => ({
  params,
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const getKonteynerContext = () => customerApi.get(`${BASE}/context`, authConfig());

// Kural kütüphanesi
export const getKonteynerKurallar = (params = {}) => customerApi.get(`${BASE}/kurallar`, authConfig(params));
export const createKonteynerKural = (payload) => customerApi.post(`${BASE}/kurallar`, payload, authConfig());
export const updateKonteynerKural = (payload) => customerApi.post(`${BASE}/kurallar/update`, payload, authConfig());
export const deleteKonteynerKural = (id) => customerApi.post(`${BASE}/kurallar/delete`, { id }, authConfig());

// Müşteri yükleme profilleri
export const getKonteynerMusteriler = () => customerApi.get(`${BASE}/musteriler`, authConfig());
export const createKonteynerMusteri = (payload) => customerApi.post(`${BASE}/musteriler`, payload, authConfig());
export const updateKonteynerMusteri = (payload) => customerApi.post(`${BASE}/musteriler/update`, payload, authConfig());
export const deleteKonteynerMusteri = (id) => customerApi.post(`${BASE}/musteriler/delete`, { id }, authConfig());

// Plan hesabı
export const hesaplaKonteynerPlan = (payload) => customerApi.post(`${BASE}/hesapla`, payload, { ...authConfig(), timeout: 60000 });

// Kayıtlı planlar
export const getKonteynerPlanlar = (params) => customerApi.get(`${BASE}/planlar`, authConfig(params));
export const getKonteynerPlan = (id) => customerApi.get(`${BASE}/plan`, authConfig({ id }));
export const kaydetKonteynerPlan = (payload) => customerApi.post(`${BASE}/planlar`, payload, authConfig());
export const deleteKonteynerPlan = (id) => customerApi.post(`${BASE}/planlar/delete`, { id }, authConfig());

// Kayıtlı planın 3D sunum sayfası (giriş + konteynerPlan_view)
export const getKonteynerPlanSunum = (id) => customerApi.get(`${BASE}/plan/sunum`, authConfig({ id }));
export const sunumYolu = (id) => `/planning/konteyner-yukleme/plan/${id}`;

// Müşteri linki (girişsiz sunum)
export const paylasKonteynerPlan = (id, gecerlilikGun) => customerApi.post(`${BASE}/planlar/paylas`, { id, gecerlilikGun }, authConfig());
export const kapatKonteynerPaylasim = (id) => customerApi.post(`${BASE}/planlar/paylasim-kapat`, { id }, authConfig());
export const getPublicKonteynerPlan = (token) => customerApi.get(`${BASE}/public/${encodeURIComponent(token)}`);
export const musteriLinki = (token) => `${window.location.origin}/yukleme-plani/${token}`;

export const apiHata = (error) =>
  error?.response?.data?.detail ||
  error?.response?.data?.msg ||
  error?.response?.data?.message ||
  error?.message ||
  "İşlem sırasında bir hata oluştu.";
